import React from 'react';

import { DonateToCharityModal } from '@hero/components/modals';

function BannerContent({ showCharityInfoModal, setShowCharityInfoModal }) {
  return (
    showCharityInfoModal && (
      <DonateToCharityModal
        isOpen={showCharityInfoModal}
        setIsOpen={setShowCharityInfoModal}
        primaryButtonProps={{
          onClick: () => setShowCharityInfoModal(false)
        }}
      />
    )
  );
}

export default BannerContent;
